export default __webpack_public_path__ + "static/media/img-proj-asaph.76f146f2.png";